<template>
  <div class="record-box">
    <app-header title="充值记录" @goback="goBack">
      <div slot="tips" class="charge-tips" @click="intoInvoice">
        <span>{{ isShowCheck ? '取消' : '发票申请' }}</span>
      </div>
    </app-header>

    <pull-to class="pull-to" :is-top-bounce="false" :is-bottom-bounce="isLoadAll" :bottom-load-method="loadmore">
      <ul class="record-list" ref="recordList">
        <li v-for="(item, index) in recordList" :key="index" @click="check(item, index)">
          <checkbox disabled v-model="checkedIds" class="checkbox" :value="item.id" v-show="isShowCheck" ref="checkbox" :class="{'disable-checkbox': item.status !== 3 || item.applyInvoiceStatus !== 0 || !customerId}"></checkbox>
          <div class="right-box">
            <div class="record-title">
              <span :class="{'pay-public': item.payType === 'PUBLIC', 'pay-online': item.payType !== 'PUBLIC'}"></span>
              <span style="margin-left: 25px;">{{ item.groupName }}</span>
            </div>
            <div class="record-num">{{`+${item.price}`}}</div>
            <div class="record-mes">
              <div>{{caclStatusText(item.status)}}</div>
              <div>{{item.applyTime}}</div>
            </div>
          </div>
        </li>
      </ul>
    </pull-to>

    <div class="button-box" v-show="isShowCheck">
      <Button @click="next">下一步</Button>
    </div>
  </div>
</template>

<script>
import AppHeader from 'components/app-header';
import apis from 'api/index';
import PullTo from 'vue-pull-to';
import { Checkbox } from 'vue-checkbox-radio';
import { Style, Button, Toast } from 'cube-ui';
import { commonMixin } from 'common/js/mixin';
import { mapMutations, mapGetters } from 'vuex';

export default {
  mixins: [commonMixin],
  components: {
    AppHeader,
    PullTo,
    Checkbox,
    Button
  },
  data() {
    return {
      recordList: [],
      recordTotal: 0,
      recordPageNumber: 1,
      recordPageSize: 10,
      checkedIds: [],
      isShowCheck: false,
    }
  },
  computed: {
    customerId() {
      return this.userAllInfo.enterprise.customerId;
    },
    isLoadAll() {
      return Boolean(this.recordTotal >= this.recordPageNumber * this.recordPageSize)
    },
    selectList() {
      // 先计算出当前选中的list集合
      let selectList = this.recordList.filter(item => {
        for(let i = 0; i < this.checkedIds.length; i++) {
          if(item.id === this.checkedIds[i]) {
            return item
          }
        }
      });
      return selectList;
    },
    ...mapGetters(['userAllInfo'])
  },
  created() {
    this.fetchRecordList();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 点击行选中
    check(item, index) {
      if(item.status !== 3) return false;
      if(!this.isShowCheck || item.applyInvoiceStatus !== 0 || !this.customerId) return false;
      this.$refs.checkbox[index].toggle(item.depId);
    },
    intoInvoice() {
      if(this.isShowCheck) {
        this.checkedIds = [];
      }
      this.isShowCheck = !this.isShowCheck;
    },
    caclStatusText(status) {
      let text = '';
      switch(status) {
        case 0:
        text = '支付失败';
        break;
        case 1:
        text = '待支付';
        break;
        case 2:
        text = '支付确认中';
        break;
        case 3:
        text = '支付成功';
        break;
        case 4:
        text = '超时未支付';
        break;
      }
      return text;
    },
    loadmore(loaded) {
      if(this.recordTotal <= this.recordPageNumber * this.recordPageSize) {
        return false;
      }
      this.recordPageNumber +=1;
      this.fetchRecordList().then(res => {
        loaded('done');
      });
    },
    async fetchRecordList() {
      try {
        let params = {
          no: this.recordPageNumber,
          limit: this.recordPageSize
        };
        const res = await apis.getPayRecords(params);
        if(res) {
          this.recordList = this.recordList.concat(res.records);
          this.recordTotal = res.total;
        }
        
      } catch(err) {
        console.error(err);
      }
    },
    next() {
      if(this.checkedIds.length === 0) {
        this.showToast('请至少选择一种开票');
        return false;
      }
      let totalPrice = this.selectList.reduce((prev, curr) => {return prev + curr.price}, 0);
      this.setInvoiceMoney(totalPrice);
      this.setInvoiceList(this.selectList);
      this.$router.push({name: 'charge-apply'});
    },
    ...mapMutations(['setInvoiceList', 'setInvoiceMoney'])
  },
  watch: {
    isShowCheck(nVal) {
      nVal ? this.$refs.recordList.style.marginBottom = '60px' : this.$refs.recordList.style.marginBottom = '0';
    }
  }
}
</script>

<style src="./charge.scss" lang="scss" scoped></style>
